import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";
import api, { fmtErr } from "@/lib/api";
import { Button } from "@/components/ui/button";

const MAX = 5 * 1024 * 1024;
const TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

export function BannerUpload({ value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!TYPES.includes(file.type)) { toast.error("Please choose a JPG, PNG, WEBP or GIF image"); return; }
    if (file.size > MAX) { toast.error("Image must be 5 MB or smaller"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/files", fd);
      onChange(`${process.env.REACT_APP_BACKEND_URL}/api/v1/files/${data.id}/download`);
      toast.success("Banner uploaded");
    } catch (err) { toast.error(fmtErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-2 mt-1">
      <input ref={ref} type="file" accept={TYPES.join(",")} className="hidden" onChange={pick} data-testid="fest-banner-file" />
      <Button type="button" size="sm" variant="outline" onClick={() => ref.current?.click()} disabled={busy} data-testid="fest-banner-upload">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Upload className="w-4 h-4 mr-1" />}{busy ? "Uploading…" : "Upload image"}
      </Button>
      {value && <img src={value} alt="Banner" className="h-8 w-14 object-cover rounded border" data-testid="fest-banner-thumb" />}
      {value && <Button type="button" size="sm" variant="ghost" onClick={() => onChange("")} data-testid="fest-banner-remove"><X className="w-4 h-4" /></Button>}
    </div>
  );
}
